import styled from 'styled-components'

import {
  TEXT_GREY, GREY_NORMAL_COLOR, GREY_DARK_COLOR, GREY_BACKGROUND, PRIMARY_DARK_COLOR,
} from '@CSSVars/colors'
import { BREAK_POINT_LG } from '@CSSVars/variables'

export const _ResultWrap = styled.div`
  width: 100%;
  position: relative;
  -webkit-transform: translate3d(0, 0, 0);;
  padding: 8px 0 5px 0;
  background-color: white;

`

export const _Result = styled.div`
  width: 100%;
  min-height:60px;
  height: 60px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  transition: all .3s;
  text-decoration: none;
  cursor: pointer;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  //margin-top: 8px;
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    @media (hover: hover) {
      &:hover {
        background: ${GREY_NORMAL_COLOR} !important;
      }
    }
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
      &:active {
        background: ${GREY_NORMAL_COLOR} !important;
      }
  }

  @media screen and (max-width: 47.9em) {
    flex-direction: column;
    height: 50px;
    justify-content: center;
    padding: 12px 15px 8px;
  }
`

export const _ResultItem = styled.div`
  width: 100%;
  flex: 1 1 auto;
  align-self: center;
  padding: 0 10px;
  text-align: left;
  color: ${PRIMARY_DARK_COLOR};
  transition: all .3s;
  line-height: 22px;
  font-size: 12px;
  font-weight: 600;

  @media screen and (max-width: 47.9em) {
    display: block;
    flex-grow: 0;
    font-size: 14px;
    padding: 0;
  }
`

export const _ResultSubtitle = styled.div`
  flex: 0 0 auto;
  align-self: center;
  color: ${GREY_DARK_COLOR};
  text-align: right;
  display: inline-block;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 50%;
  line-height: 22px;
  font-weight: 500;
  padding-right: 8px;
  @media screen and (max-width: 47.9em) {
    display: block;
    flex-grow: 0;
    line-height: 22px;
    align-self: flex-start;
    font-size: 12px;
    max-width: 100%;
    color: ${TEXT_GREY};
  }
`

export const _ResultBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 5px);
  transform: translate3d(0,0,0);
  opacity: ${({ isHighlighted }) => (isHighlighted ? '0.2' : '0.05')};
  z-index: 0;
`
